import {connectVsegdaDa} from "@/helpers/pay/connection/connectionVsegdaDa";
import {checkInitializationVsegdaDa} from "@/helpers/pay/helpers";
import {send} from "@/components/fetchData";
import {emitter} from "@/components/databus";

/** Произвести покупку через рассрочку / кредит от Хоум банка
 * @param { Number } idOrder - id заказа
 * @param { Array } idsCourses - массив id курсов
 * */
let installmentPayVsegdaDa = (idOrder, idsCourses) => {
  apiGetInfoInstallment(idOrder).then(
    response => createInstallmentPay(response, idsCourses),
    error => errorHandler(error)
  )
};

/** Инициализировать оплату через Хоум банк
 * @param {Number} idOrder - id заказа
 * @returns {Promise}
 */
let apiGetInfoInstallment = (idOrder) => {
  return new Promise((resolve, reject) => {
    send
      .post('unregistered.php', {
        module: 'get_payment_home_credit',
        order_id: idOrder,
      })
      .then(response => resolve(response))
      .catch(error => reject(error))
  });
};

/** Обработчик ошибок
 * @param {Object} error - данные ошибки
 * */
let errorHandler = (error) => {
  console.log('get_payment_home_credit error', error);
  console.log(error.response);
};

/** Создать оплату рассрочки Хоум банка / вызвать метод генерации заявки на кредит
 * @param {Object} response - данные с апи по составу заказа
 * @param {Array} idsCourses - массив id курсов
 * */
let createInstallmentPay = (response, idsCourses) => {
  // Создает оплату
  let createPay = (idsCourses) => {
    let objPay = response.data; // данные объекта для оплаты
    objPay.partnerUrl = `https://ri-ege.ru/lk/gk/?type=vsegdaDaPay&payStatus=successfully&idCourses=${ getTextCourses(idsCourses) }&amount=${ response.amount }`;
    objPay.view = 'self';

    vd.create(objPay);
  };

  // Получить id курсов в текстовом формате
  let getTextCourses = (idsCourses) => {
    return idsCourses.reduce((accumulator, item) => {
      if (!accumulator) return item;
      return accumulator + '.' + item;
    }, '');
  };

  const isTestPay = response.is_demo; // является ли оплата тестовой
  connectVsegdaDa(isTestPay); // функция подключения оплаты от Всегда.Да (Хоум банк)
  checkConnectVsegdaDaScript().then(
    result => createPay(idsCourses),
    error => errorConnectVsegdaDa(error)
  )
};

/** Проверить подключение скрипта от Хоум банка
 * @returns {Promise} успешно ли подключение
 */
let checkConnectVsegdaDaScript = () => {
  let waitingTime = 5; // время в секундах для ожидания подключения скрипта
  let intervalCheck = undefined;

  // Возвращает информацию о статусе подключения виджета (подключен ли виджет)
  let isConnect = () => window.vd !== void 0;

  // Возвращает данные с успехом
  let createResolveEmit = (resolve) => {
    clearInterval(intervalCheck);
    resolve();
  };

  //  Возвращает данные с ошибкой
  let createRejectEmit = (reject) => {
    clearInterval(intervalCheck);
    reject('connect_error');
  };

  return new Promise((resolve, reject) => {
    if (isConnect()) resolve();

    intervalCheck = setInterval(() => {
      waitingTime--;
      if (isConnect()) createResolveEmit(resolve)
      else if (waitingTime <= 0) createRejectEmit(reject)
    }, 1000);
  });
}

/** Сообщение о неуспехе подключения виджета
 * @param {String}  typeError - тип ошибки, который необходимо обработать
 * */
let errorConnectVsegdaDa = (typeError) => {
  if (typeError === 'connect_error') openErrorModal('Не удалось подключить платежный виджет, обратитесь к техническому специалисту')
  else openErrorModal('Ошибка! Платёж не прошёл');
};

/** Открыть модальное окно с ошибкой
 * @param {String} text - текст ошибки
 * @param {Number} time - время отображения модального окна
 * */
let openErrorModal = (text, time = 4) => {
  emitter.emit('openGlobalNotifications', {
    show: true,
    time: time,
    text: text,
    type: 'error'
  });
};

export { installmentPayVsegdaDa };